module.exports = __webpack_public_path__ + "img/hr-rail-endings-metals.590c25b5.png";